import { getApi, postApi } from '../../../utils/api'

export function startExport(data) {
  return postApi({
    data,
    endpoint: '/idwell-api/api/v3/request/requests/zip-export/',
  })
}

export function checkTask(id) {
  return getApi({ endpoint: `/api/request-export-as-zip-files-task/${id}/` })
}
